import React from "react";
import {Link} from "react-router-dom";
import {LoggedInRoutes} from "../../../LoggedInRoutes";
import SystemEntityStatus from "./ui/SystemEntityStatus";
import ClusterHealthStatus from "./ui/ClusterHealthStatus";
import ClusterTapThroughputChart from "./ClusterTapThroughputChart";
import CurrentClusterThroughput from "./CurrentClusterThroughput";
import ReportTime from "./ui/ReportTime";

export default function ClusterCard({cluster}) {

  const hasThroughput = cluster.tap_throughput.some((t) => t.value > 0);

  return (
      <div className="section cluster-card">
        <div className="cluster-card-header">
          <Link to={LoggedInRoutes.CLUSTERS.SHOW(cluster.uuid)} className="cluster-name">
            <SystemEntityStatus status={cluster.status}/>
            <span>{cluster.name}</span>
          </Link>

          <ClusterHealthStatus cluster={cluster} showGreen={true} />
        </div>

        <dl className="cluster-card-stats">
          <div>
            <dt>Throughput</dt>
            <dd className="cluster-card-throughput">
              {hasThroughput ? <CurrentClusterThroughput cluster={cluster} inline={true} showZero={true} /> : <span className="color-muted">n/a</span>}
            </dd>
          </div>

          <div>
            <dt>Last Report</dt>
            <dd><ReportTime time={cluster.last_report_received_at} /></dd>
          </div>
        </dl>

        {hasThroughput && (
            <ClusterTapThroughputChart cluster={cluster}
                                       xAxis={{lineWidth: 1, lineColor: "#2a2a33", gridColor: "#25252d"}}
                                       yAxis={{lineWidth: 1, lineColor: "#2a2a33", gridColor: "#25252d"}}
                                       colors={{bar: "#c4c4d4"}}
                                       margins={{l: 100, r: 10, b: 30, t: 5, pad: 0}}
                                       height={130}/>
        )}
      </div>
  )

}
